import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AdminTokenInterceptor } from './core/interceptors/admin-token.interceptor';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { HomeComponent } from './pages/home/home.component';
import { AboutComponent } from './pages/about/about.component';
import { ServicesComponent } from './pages/services/services.component';
import { ProductsComponent } from './pages/products/products.component';
import { CertificatesComponent } from './pages/certificates/certificates.component';
import { ContactComponent } from './pages/contact/contact.component';
import { AdminLoginComponent } from './pages/admin/admin-login/admin-login.component';
import { AdminDashboardComponent } from './pages/admin/admin-dashboard/admin-dashboard.component';
import { AdminProductsComponent } from './pages/admin/admin-products/admin-products.component';
import { AdminCertificatesComponent } from './pages/admin/admin-certificates/admin-certificates.component';
import { AdminContactRequestsComponent } from './pages/admin/admin-contact-requests/admin-contact-requests.component';
import { AdminHomeComponent } from './pages/admin/admin-home/admin-home.component';
import { AdminAboutComponent } from './pages/admin/admin-about/admin-about.component';
import { AdminServicesComponent } from './pages/admin/admin-services/admin-services.component';
import { AdminSocialLinksComponent } from './pages/admin/admin-social-links/admin-social-links.component';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AboutComponent,
    ServicesComponent,
    ProductsComponent,
    CertificatesComponent,
    ContactComponent,
    AdminLoginComponent,
    AdminDashboardComponent,
    AdminProductsComponent,
    AdminCertificatesComponent,
    AdminContactRequestsComponent,
    AdminHomeComponent,
    AdminAboutComponent,
    AdminServicesComponent,
    AdminSocialLinksComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule
  ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AdminTokenInterceptor,
            multi: true
        }
    ],
  bootstrap: [AppComponent]
})
export class AppModule { }
